import './App.css';
import Footer from './Footer';
import Header from './Header';
import Home from './Home';

function App() {
  return (
   <div>
   <Header/>
   <Home/>
   <Footer/>
   </div>
  );
}

export default App;
